import { func, shape } from 'prop-types';

const actions = shape({
  abandonBasketError: func.isRequired,
  acceptTerms: func.isRequired,
  addSecurityPackageLink: func.isRequired,
  agencySubIdError: func.isRequired,
  backEndError: func.isRequired,
  customerError: func.isRequired,
  customerLeave: func.isRequired,
  customerValidField: func.isRequired,
  finalCleaningError: func.isRequired,
  firePayButtonClick: func.isRequired,
  hideAbandonBasket: func.isRequired,
  initFromCookies: func.isRequired,
  initFromDrupal: func.isRequired,
  interactCustomerInfo: func.isRequired,
  nextStep: func.isRequired,
  pay: func.isRequired,
  paymentError: func.isRequired,
  prevStep: func.isRequired,
  receiveFromBackend: func.isRequired,
  receivedDibsForm: func.isRequired,
  requestFromBackend: func.isRequired,
  selectPaymentOption: func.isRequired,
  selectPaymentType: func.isRequired,
  sendAbandonBasket: func.isRequired,
  setOriginalAgencyInfo: func.isRequired,
  startSubmitLoading: func.isRequired,
  stopLoading: func.isRequired,
  submitAbandonBasket: func.isRequired,
  termsError: func.isRequired,
  toggleAbandonBasketTerms: func.isRequired,
  updateAbandonBasketState: func.isRequired,
  updateAdditionalChildren: func.isRequired,
  updateAgencyMessage: func.isRequired,
  updateAgencyNumber: func.isRequired,
  updateAgencySubId: func.isRequired,
  updateAgencyUserId: func.isRequired,
  updateBookingOverview: func.isRequired,
  updateCustomerDialCode: func.isRequired,
  updateCustomerInfo: func.isRequired,
  updateCustomerPhone: func.isRequired,
  updateExtraServices: func.isRequired,
  updateFromBackend: func.isRequired,
  updateGuests: func.isRequired,
  updateGuestsOptions: func.isRequired,
  updateNarrowState: func.isRequired,
  updateOrderType: func.isRequired,
  updateSalesChannel: func.isRequired,
  updateTickets: func.isRequired,
  updateTotalSteps: func.isRequired,
  updateVoucherCode: func.isRequired,
  updateVoucherFromBackend: func.isRequired,
  validateVoucher: func.isRequired,
  voucherError: func.isRequired,
});

export { actions as default };
